import React from 'react';

// A flexible box component that uses Flexbox.
export const Flex = (props: React.HTMLAttributes<HTMLDivElement>) => (
  <div {...props} style={{ display: 'flex', ...props.style }}>
    {props.children}
  </div>
);

// A simple div wrapper.
export const Box = (props: React.HTMLAttributes<HTMLDivElement>) => <div {...props} />;

// A heading component that can be h1, h2, etc.
export const Heading = (props: React.HTMLAttributes<HTMLHeadingElement> & { as?: 'h1' | 'h2' | 'h3' | 'h4' }) => {
  const Tag = props.as || 'h1';
  // We remove 'as' from the props passed to the DOM element
  const { as, ...rest } = props;
  return <Tag {...rest} />;
};

// A text component for paragraphs or spans.
export const Text = (props: React.HTMLAttributes<HTMLParagraphElement>) => <p {...props} />;

// A layout component for simple centering
const CenterLayout = (props: React.HTMLAttributes<HTMLDivElement>) => (
    <Flex 
        {...props}
        style={{
            width: '100%',
            height: '100%',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            ...props.style
        }}
    />
);

export const SlideLayout = {
    Center: CenterLayout,
    // We can add more layouts here later, e.g., TwoColumn
};